import { TbInfoCircle } from "react-icons/tb";
import "./StatLabelInfoTooltip.scss";

export const CLEARED_SUBMISSIONS_STATS_TOOLTIP =
  "This figure excludes cleared question submissions, such as those removed when you reset progress on a module or subject.";

type StatLabelInfoTooltipProps = {
  id: string;
  text?: string;
};

const StatLabelInfoTooltip = ({
  id,
  text = CLEARED_SUBMISSIONS_STATS_TOOLTIP,
}: StatLabelInfoTooltipProps) => (
  <span className="stat-label-info-tooltip">
    <button
      type="button"
      className="stat-label-info-tooltip__trigger"
      aria-describedby={id}
    >
      <TbInfoCircle aria-hidden="true" />
    </button>
    <div id={id} className="stat-label-info-tooltip__content" role="tooltip">
      {text}
    </div>
  </span>
);

export default StatLabelInfoTooltip;
